
import { ThumbnailOverlay } from '@/store/videoFeatures/types';

export const getButtonProperty = (thumbnail: ThumbnailOverlay, property: string): any => {
  const actionButton = thumbnail.actionButton as any;
  if (!actionButton) return '';
  
  if (property.includes('.')) {
    const [parent, child] = property.split('.');
    return actionButton[parent]?.[child] || '';
  }
  
  return actionButton[property] || '';
};

export const getThumbnailButtonColors = (thumbnail: Partial<ThumbnailOverlay>) => {
  if (!thumbnail?.actionButton) return null;
  
  const actionButton = thumbnail.actionButton as any;
  
  // Check if it's the old format with direct 'colors' property
  if (actionButton.colors) {
    return {
      background: actionButton.colors.background,
      text: actionButton.colors.text,
      hover: actionButton.colors.hover
    };
  } 
  
  return null;
};
